module.exports = __webpack_public_path__ + "media/img/logos/2023/graduate_day-c1f971a3aaabdb979df218dacdcabd9a.svg";